import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useTemplateList } from '../../hooks/useTemplates'
import { EmptyState } from '../../components/feedback/EmptyState'
import styles from '../_shared/CrudPage.module.css'

const TIPOS_OS = [
  { value: '', label: 'Todos os tipos' },
  { value: 'preventivo', label: 'Preventivo' },
  { value: 'corretivo', label: 'Corretivo' },
  { value: 'higienizacao', label: 'Higienização' },
  { value: 'qai', label: 'Análise QAI' },
  { value: 'desinfeccao_legionella', label: 'Desinfecção — Legionella' },
]

const TIPOS_EQUIPAMENTO = [
  { value: '', label: 'Todos os equipamentos' },
  { value: 'split_hi_wall', label: 'Split Hi-Wall' },
  { value: 'split_cassete', label: 'Split Cassete' },
  { value: 'split_piso_teto', label: 'Split Piso-Teto' },
  { value: 'split_duto', label: 'Split Dutado' },
  { value: 'vrf_condensadora', label: 'VRF Condensadora' },
  { value: 'vrf_evaporadora', label: 'VRF Evaporadora' },
  { value: 'chiller', label: 'Chiller' },
  { value: 'self_contained', label: 'Self-Contained' },
  { value: 'uta', label: 'UTA' },
  { value: 'fancoil', label: 'Fan Coil' },
  { value: 'torre_resfriamento', label: 'Torre de Resfriamento' },
  { value: 'condensadora_ar', label: 'Condensadora a Ar' },
  { value: 'janela', label: 'AC Janela' },
  { value: 'ptac', label: 'PTAC' },
  { value: 'outro', label: 'Outro' },
]

export default function TemplatesListPage() {
  const [tipoOs, setTipoOs] = useState('')
  const [tipoEq, setTipoEq] = useState('')
  const params: Record<string, string> = {}
  if (tipoOs) params.tipo_os = tipoOs
  if (tipoEq) params.tipo_equipamento = tipoEq
  const { data, isLoading } = useTemplateList(
    Object.keys(params).length ? params : undefined,
  )

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div>
          <h1 className={styles.title}>Templates de checklist</h1>
          <p className={styles.subtitle}>
            Modelos de inspeção (NBR 17.037:2023).
          </p>
        </div>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <Link
            to="/checklists/templates/importar"
            data-testid="btn-templates-importar"
            style={{
              padding: '0.5rem 1rem',
              background: 'white',
              color: '#1565C0',
              border: '1px solid #1565C0',
              borderRadius: 4,
              textDecoration: 'none',
              fontWeight: 600,
            }}
          >
            📥 Importar planilha
          </Link>
          <Link to="/checklists/templates/novo" className={styles.btnNovo ?? ''}>
            + Novo template
          </Link>
        </div>
      </header>

      <div className={styles.toolbar}>
        <select
          className={styles.search}
          style={{ maxWidth: 240 }}
          value={tipoOs}
          onChange={(e) => setTipoOs(e.target.value)}
          data-testid="template-filtro-tipo-os"
        >
          {TIPOS_OS.map((t) => (
            <option key={t.value} value={t.value}>
              {t.label}
            </option>
          ))}
        </select>
        <select
          className={styles.search}
          style={{ maxWidth: 260 }}
          value={tipoEq}
          onChange={(e) => setTipoEq(e.target.value)}
          data-testid="template-filtro-tipo-equipamento"
        >
          {TIPOS_EQUIPAMENTO.map((t) => (
            <option key={t.value} value={t.value}>
              {t.label}
            </option>
          ))}
        </select>
      </div>

      {isLoading ? (
        <div className={styles.loading}>Carregando templates...</div>
      ) : (
        <div className={styles.grid}>
          {data?.results.map((tpl) => (
            <Link
              key={tpl.id}
              to={`/checklists/templates/${tpl.id}`}
              className={styles.card}
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <div className={styles.cardHeader}>
                <span
                  style={{
                    fontSize: 11,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    color: 'var(--text-secondary)',
                    fontWeight: 600,
                  }}
                >
                  Template v{tpl.versao}
                </span>
                <span
                  className={styles.badge}
                  style={{
                    background: tpl.ativo ? '#E8F5E9' : '#F5F5F5',
                    color: tpl.ativo ? '#2E7D32' : '#757575',
                  }}
                >
                  {tpl.ativo ? 'Ativo' : 'Inativo'}
                </span>
              </div>
              <h3 className={styles.cardTitle}>{tpl.nome}</h3>
              <p className={styles.cardSub}>
                {tpl.tipo_os_display ?? tpl.tipo_os}
                {tpl.tipo_equipamento && ` • ${tpl.tipo_equipamento_display ?? tpl.tipo_equipamento}`}
              </p>
              <div className={styles.cardFooter}>
                <span className={styles.cardSub}>
                  {tpl.itens?.length ?? 0} ite{(tpl.itens?.length ?? 0) === 1 ? 'm' : 'ns'}
                </span>
              </div>
            </Link>
          ))}
          {data?.results.length === 0 && (
            <EmptyState
              icon="📑"
              title={
                tipoOs || tipoEq
                  ? 'Nenhum template bate com os filtros'
                  : 'Nenhum template de checklist'
              }
              description={
                tipoOs || tipoEq
                  ? 'Tente limpar os filtros ou criar um template novo pro tipo selecionado.'
                  : 'Templates definem os itens que o técnico vai checar em campo (vazamento, pressão, ruído, etc).'
              }
              actionTo="/checklists/templates/novo"
              actionLabel="+ Novo template"
            />
          )}
        </div>
      )}
    </div>
  )
}
